import { Text } from "@fluentui/react-components";
import { useIntl } from "react-intl";
import { useChatStyle } from "./style";

export const DropFilesOverlay: React.FC = () => {
	const classes = useChatStyle();
	const intl = useIntl();

	return (
		<div className={classes.dropOverlay}>
			<Text>
				{intl.formatMessage({ id: "Interaction.EmailEditor.DropFiles" })}
			</Text>
		</div>
	);
};
